export const GLOBAL_TOPIC_IDS_KEY = 'globalTopicIds'
export const NOT_GLOBAL_TOPIC_IDS_KEY = 'notGlobalTopicIds'
